import React from 'react';
export function Footer() {
  return <footer className="bg-[#4A3B32] text-white py-12" data-id="element-32">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl" data-id="element-33">
        <div className="flex flex-col md:flex-row justify-between items-center mb-8" data-id="element-34">
          <div className="mb-4 md:mb-0" data-id="element-35">
            <span className="font-serif text-2xl font-bold" data-id="element-36">
              Adiós<span className="text-[#14B8A6]" data-id="element-37">Panza</span>
            </span>
          </div>
          <div className="text-sm text-gray-400" data-id="element-38">
            © {new Date().getFullYear()} Todos los derechos reservados.
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8 flex flex-col md:flex-row justify-between text-xs text-gray-400" data-id="element-39">
          <p className="max-w-xl mb-4 md:mb-0" data-id="element-40">
            Descargo de responsabilidad: Este producto no sustituye el consejo
            médico profesional. Si tienes problemas de salud crónicos, consulta
            a tu médico antes de realizar cambios en tu dieta o rutina. Los
            resultados pueden variar de una persona a otra.
          </p>
          <div className="flex space-x-6" data-id="element-41">
            <a href="#" className="hover:text-[#14B8A6] transition-colors" data-id="element-42">
              Privacidad
            </a>
            <a href="#" className="hover:text-[#14B8A6] transition-colors" data-id="element-43">
              Términos
            </a>
            <a href="#" className="hover:text-[#14B8A6] transition-colors" data-id="element-44">
              Contacto
            </a>
          </div>
        </div>
      </div>
    </footer>;
}